/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';

import type { TrackEvent } from './types';
import { useAlertBanner } from './useAlertBanner/useAlertBanner';
import { Currency } from '@zapier/currency';
import { useQueryGetCurrencies } from '../../hooks';
import { useEffect } from 'react';

type Props = {
  /**
   * Function to track user events when they occur.
   */
  trackEvent: TrackEvent;
};

/**
 * The banner that renders above `UniversalNav` for important alerts.
 */
export const AlertBanner = (props: Props) => {
  const { Component, data: alertBannerData } = useAlertBanner();

  const {
    data: currenciesData,
    isLoading: isLoadingCurrencies,
    isError: isErrorCurrencies,
  } = useQueryGetCurrencies();

  useEffect(() => {
    setTimeout(() => {
      /**
       * Trigger UniversalNav to recalculate the sidebar height after the <AlertBanner> is rendered.
       * Without this, the sidebar will be too tall which causes <UniversalSidebarTrialHub>
       * to render off screen because it is anchored to the bottom of the sidebar.
       */
      window.dispatchEvent(new Event('resize'));
    });
  });

  if (
    !Component ||
    isLoadingCurrencies ||
    isErrorCurrencies ||
    !alertBannerData ||
    !currenciesData
  ) {
    return null;
  }

  const targetCurrency = currenciesData.find(
    (c: Currency) => c.name === alertBannerData?.currentAccount.currency
  );

  return (
    <Component
      data={alertBannerData}
      currency={targetCurrency}
      layout="banner"
      trackEvent={props.trackEvent}
    />
  );
};
